<template>
  <nav id="sidebar" class="sidebar-wrapper">
    <div class="sidebar-content d-flex flex-column">
      <div class="sidebar-brand">
        <a href="/">Annotator</a>
        <div id="minimize-sidebar" class="ml-3" style="cursor:pointer">
          <i class="fas fa-angle-left"></i>
          <i class="fas fa-thumbtack d-none"></i>
        </div>
      </div>
      <!-- sidebar-header  -->
      <div class="sidebar-item sidebar-search">
		<div class="input-group">
      	  <a href="/search" style="width: 100%">
      	  	<button type="button" class="btn mb-0" style="width: 100%" :class="{'btn-secondary' : user.is_admin, 'btn-light' : !user.is_admin}">
	        	<i class="fas fa-search mr-1" style="vertical-align: middle; color: inherit;"></i>
				<div style="display: inline-block; vertical-align: middle;">{{ __('translations.button.search') }}</div>
	        </button>
      	  </a>
		</div>
      </div>
      
      <div class="sidebar-item sidebar-menu flex-grow-1">
        <ul>
          <li class="header-menu">
            <span>{{__('translations.configuration')}}</span>
          </li>
          <li style="padding: 8px 30px 8px 20px;">
          	<!-- Preview annotations -->
		 	<div class="custom-control custom-switch">
			  <input type="checkbox" class="custom-control-input" id="previewAnnotationSwitch" :checked="previewAnnotations" @click="togglePreviewAnnotations($event)" />
			  <label class="custom-control-label" for="previewAnnotationSwitch"><span class="custom-control-label-text">{{ __('translations.menu.preview_annotations') }}</span></label>
			</div>
          </li>
          <li v-if="user.is_admin">
          	<router-link :to="{name: 'dashboard'}">
                <i class="fa fa-tachometer-alt"></i>
                <span class="menu-text">{{ __('translations.title.dashboard') }}</span>
            </router-link>
          </li>
        </ul>
        <ul>
          <li class="header-menu">
            <span>{{__('translations.artifacts')}}</span>
          </li>
          <li class="sidebar-dropdown">
            <a href="#" ref="documents">
              <i class="fas fa-file-contract"></i>
              <span class="menu-text">{{__('translations.notebooks')}}</span>
              <span class="badge badge-pill badge-success">{{documentMenu.length}}</span>
            </a>
            <div v-if="documentMenu.length > 0" class="sidebar-submenu">
              <ul>
                <li v-for="doc in documentMenu" :id="'doc-' + doc.id" :key="doc.id">
                  <router-link :to="{name: 'document', params: {id: doc.id}}">{{doc.document_name}}</router-link>
                </li>
              </ul>
            </div>
          </li>
          <li class="sidebar-dropdown">
            <a href="#" ref="images">
              <i class="fas fa-image"></i>
              <span class="menu-text">{{ __('translations.title.images') }}</span>
              <span class="badge badge-pill badge-success">{{imageMenu.total}}</span>
            </a>
            <div class="sidebar-submenu">
              <ul>
              	<li id="reported-images">
              	  <router-link :to="{name: 'reported-images'}">{{__('translations.menu.reported_images')}}</router-link>
              	</li>
                <li v-for="list in imageMenu.list" :id="'image-' + list.from + '-' + list.to" :key="list.from">
                  <router-link :to="{name: 'images', params: {from: list.from, to: list.to}}">{{list.from}} - {{list.to}}</router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <!-- sidebar-menu  -->
    </div>
	<!-- sidebar-content  -->
    <div class="sidebar-footer">
      <div><a href="/about"><i class="fas fa-info-circle"></i></a></div>
      <div><a href="/user/profile"><i class="fas fa-user"></i></a></div>
      <div><span @click="logout"><i class="fa fa-power-off"></i></span></div>
      <div class="pinned-footer"><a href="#"><i class="fas fa-ellipsis-h"></i></a></div>
    </div>
  </nav>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	data: () => ({
		csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
	}),
	props: ['user', 'redirect', 'documentMenu', 'imageMenu'],
	computed: {
		...mapGetters([
			'previewAnnotations'
		])
	},
	mounted() {
		if(this.$route.path !== this.redirect.path && this.redirect.path !== '/') {
			this.$router.push(this.redirect);
		}
		
		if (this.$route.name === 'document') {
			var $element = $('#doc-' + this.$route.params.id)
		} else if (this.$route.name === 'images') {
			var $element = $('#image-' + this.$route.params.from + '-' + this.$route.params.to);
		} else if (this.$route.name === 'reported-images') {
			var $element = $('#reported-images');
		}
		
		this.scrollIntoView($element);
	},
	methods:{
		logout() {
			axios.post('/logout').then(function (response) {
				if (response.status === 302 || 401) {
					document.location.href = '/login';
				} else {
					// throw error and go to catch block
				}
			}).catch(error => {
				consol.log('Couldn\'t log out!');
			});
		},
		scrollIntoView($element) {
			if(typeof $element !== 'undefined' && $element.length) {
				var $sidebarDropdown = $element.parents('.sidebar-dropdown');	
				if($sidebarDropdown.length) {
					$sidebarDropdown.addClass('active');
					$sidebarDropdown.find('div.sidebar-submenu').slideDown(200);
				}
				
				var elementOffsetTop = $element.offset().top;
				var elementHeight = $element.height();
				var sidebarHeight = $('.sidebar-content').height();
				var offset = (elementHeight < sidebarHeight) ? elementOffsetTop - ((sidebarHeight / 2) - (elementHeight / 2)) : elementOffsetTop;
				
				$('.sidebar-menu').animate({
				    scrollTop: offset
				}, 500);
			}
		},
		togglePreviewAnnotations(event) {
			this.$store.commit('SET_PREVIEW_ANNOTATIONS', event.target.checked);
		}
	},
}
</script>